/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  myServices: []
};

export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_SERVICES_DONE:
      return { ...state, myServices: action.data.items };
    case AT.ITEM_DELETE_DONE:
      if (action.itemType === 'Service') {
        return {
          ...state,
          myServices: R.reject((s: any) => s._id === action.itemId, state.myServices)
        };
      }

      return state;
    default:
      return state;
  }
}
